
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/match/parlor-requests/[id]",
      function () {
        return require("private-next-pages/match/parlor-requests/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/match/parlor-requests/[id]"])
      });
    }
  